"use client"

const BackToTop = () => (
  <button
    type="button"
    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
    className="w-full bg-zl-black border-b border-zl-line-dark text-zl-mute hover:text-zl-red zl-label py-4 transition-colors duration-100"
  >
    &uarr; Volver arriba
  </button>
)

export default BackToTop
